export default class TaskStatusService {
    static get NotStarted() {
        return {
            id: 1,
            label: "Not Started",
        };
    }
    static get InProgress() {
        return {
            id: 2,
            label: "In Progress",
        };
    }
    static get Completed() {
        return {
            id: 3,
            label: "Completed",
        };
    }
    static get Cancelled() {
        return {
            id: 4,
            label: "Cancelled",
        };
    }
    static get Statuses() {
        return [
            TaskStatusService.NotStarted,
            TaskStatusService.InProgress,
            TaskStatusService.Completed,
            TaskStatusService.Cancelled,
        ];
    }
    // The task statuses to be considered as active in the system
    static get ActiveStatuses() {
        return [TaskStatusService.NotStarted, TaskStatusService.InProgress];
    }
    static getIconAndColor(taskStatusId) {
        switch (taskStatusId) {
            case TaskStatusService.NotStarted.id:
                return { icon: "hourglass-end", color: "dark" };
            case TaskStatusService.InProgress.id:
                return { icon: "clock", color: "info" };
            case TaskStatusService.Completed.id:
                return { icon: "check", color: "success" };
            case TaskStatusService.Cancelled.id:
                return { icon: "times", color: "danger" };
            default:
                return { icon: "question", color: "dark" };
        }
    }
}
